import { updateJobSelect } from "./jobicons";

const jobSelectList = () => ({
  open: false,
  selectedJobs: [],

  init() {
    this.$watch('selectedJobs', () => (updateJobSelect([...this.selectedJobs])));
  },

  toggleDisplay(job) {
    if (this.selectedJobs.includes(job)) {
      this.remove(job);
    } else {
      this.add(job);
    }
  },

  setDisplay(present, absent) {
    absent.forEach((job) => (this.remove(job)));
    present.forEach((job) => (this.add(job)));
  },

  remove(job) {
    if (this.selectedJobs.includes(job))
      this.selectedJobs.splice(this.selectedJobs.indexOf(job), 1);
  },

  add(job) {
    if (!this.selectedJobs.includes(job))
      this.selectedJobs.push(job);
  }
});

export default jobSelectList;
